import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ManagedSettingsStoreActions } from '../../../../shared/managed-settings-store/index';
import { ManagedSettingsMaximumResidentUsersComponent, MaximumResidentUsers } from './maximum-resident-users.component';

@Component({
  selector: 'ml-maximum-resident-users',
  templateUrl: './maximum-resident-users.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ManagedSettingsMaximumResidentUsersComponent],
})
export class ManagedSettingsMaximumResidentUsersContainerComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);

  private udid: string;

  // TODO: Refactor to getting the UDID with NGRX later.
  private readonly subscriptions: Subscription[] = [];

  maximumResidentUsers(maximumResidentUsers: MaximumResidentUsers) {
    this.store.dispatch(
      ManagedSettingsStoreActions.ManagedSettingsCommandActions.maximumResidentUsers({
        udid: this.udid,
        maximumResidentUsers: maximumResidentUsers.maximumResidentUsers,
      })
    );
  }

  ngOnInit() {
    if (!this.route.parent) {
      return;
    }

    this.subscriptions.push(
      this.route.parent.params
        .pipe(
          map((p: Params) => p.udid),
          filter((udid) => udid),
          distinctUntilChanged()
        )
        .subscribe((id) => (this.udid = id))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
